import { getCookie } from './cookies.script'
import { authCompany } from './authentication.script'

export function getCopilotToken(): string {
  return getCookie('access') || ''
}

export function isCopilotAllowed(): boolean {
  const roles = authCompany()?.roles ?? []
  return roles.some(r => r === 'super_admin' || r.startsWith('bo_'))
}
